import type {DesignerStores} from '@packages/systems/designer/flux';
import {abilityFeature} from '../abilityFeature';

export const getOptimizeMode = (state: DesignerStores['OptimizationStore']) => {
  return state?.currentVariationId ? 'in-optimize' : 'out-of-optimize';
};

export const optimization = abilityFeature({
  key: 'optimization',
  isValid: function isOptimizationValid(state, config) {
    const currentOptimizationMode = getOptimizeMode(state.OptimizationStore);

    if (!config.mode) return true;

    return Boolean(config.mode === currentOptimizationMode);
  },
});
